import { ApolloClient, InMemoryCache } from '@apollo/client/core';

import { subgraphEndpoints } from '@/constants/subgraphEndpoints';

/**
 * ERC1155
 */

export const theGraphAniftyERC1155Client = new ApolloClient({
  uri: subgraphEndpoints.AniftyERC1155V1,
  cache: new InMemoryCache(),
});

export const theGraphAniftyERC1155V2Client = new ApolloClient({
  uri: subgraphEndpoints.AniftyERC1155V2,
  cache: new InMemoryCache(),
});

/**
 * Marketplace
 */

export const theGraphAniftyMarketplaceV1Client = new ApolloClient({
  uri: subgraphEndpoints.AniftyMarketplaceV1,
  cache: new InMemoryCache(),
});

export const theGraphAniftyMarketplaceV2Client = new ApolloClient({
  uri: subgraphEndpoints.AniftyMarketplaceV2,
  cache: new InMemoryCache(),
});

export const theGraphAniftyMarketplaceV3Client = new ApolloClient({
  uri: subgraphEndpoints.AniftyMarketplaceV3,
  cache: new InMemoryCache(),
});
